import { cakeApi, cakeBaseURL, bocapioKey } from "./../config"
import store from '@/store';
import { handleCache } from "@/store/utils/cache"
export default {
  login(username, password) {
    const params = new URLSearchParams();
    params.append("data[User][username]", username);
    params.append("data[User][password]", password);
    params.append("printMsg", "");
    params.append("onResponseCode", "");
    return cakeApi.post(
      '/users/login?cors=["user","userid","printMsg","onResponseCode"]',
      params
    )
  },
  getProdutos() {
    return this.getAjax('products', 'list', '?layout=ajax', 'GET', 'jsonp')
  },
  saveClient(form) {
    return this.getAjax('clients', 'save', '?bckey=true&iframed=true', 'POST', 'jsonp', false, form)
  },
  getClientes() {
    return this.getAjax('clients', 'list', '?layout=ajax', 'GET', 'jsonp')
  },
  getCliente(id) {
    return this.getAjax('clients', `view/${id}`, '?layout=ajax', 'GET', 'jsonp')
  },
  getTotalClients() {
    return this.getAjax('clients', 'count/total', '?layout=ajax', 'GET', 'json')
  },
  getPendenciesClients() {
    return this.getAjax('transactions', 'pendents_by_client/all', '?layout=ajax', 'GET', 'json')
  },
  getAveragePaymentTime() {
    return this.getAjax('bills', 'closed_bills/year', '?layout=ajax&nonf', 'GET', 'json')
  },
  getServicesPendecies() {
    return this.getAjax('bills', 'pendent_services/year', '?layout=ajax', 'GET', 'json')
  },
  getCountries() {
    return this.getAjax('app', 'countries', '?layout=ajax', 'GET', 'jsonp')
  },
  getCountriesDialcode() {
    return this.getAjax('app', 'countries/dialcode', '?layout=ajax', 'GET', 'json')
  },
  getUF(countrieId) {
    return this.getAjax('app', `states/${countrieId}`, '?layout=ajax', 'GET', 'jsonp')
  },
  getCities(ufId) {
    return this.getAjax('app', `cities/${ufId}`, '?layout=ajax', 'GET', 'jsonp')
  },
  getAgents(uuid) {
    if (undefined == uuid) {
      uuid = 0
    }
    return this.getAjax('agents', 'list/' + uuid, '?layout=ajax', 'GET', 'json')
  },
  getFieldsMap(model) {
    return this.getAjax(model, 'map', '', 'GET', 'json')
  },
  saveAgent(agentData) {
    return this.getAjax('agents', 'save', '?vuejs=true', 'POST', 'json', false, agentData)
  },
  getPublicData(place_uuid) {
    return this.getAjax('places', `public_data/${place_uuid}`, '?layout=ajax&host=' + document.location.host, 'GET', 'json')
  },
  getPlacesList(parms) {
    return this.getAjax('places', `list/${parms}`, '?layout=ajax', 'GET', 'json')
  },
  getFormations() {
    return this.getAjax('agents', `formations`, '?layout=ajax', 'GET', 'json')
  },
  whoAmI(uuid) {
    return this.getAjax('users', `whoami/${uuid}`, '?layout=ajax', 'GET', 'json')
  },

  /**
   * Metadados (Hashcodes)
   */
  createUpdateMetadata(hashcode, hash) {
    console.log('hhh', hash)
    if (hash != '') {
      return this.getAjax('messages', 'json/update_hashcode', '', 'POST', 'jsonp', false, { uuid: hashcode.uuid, uuid_ref: hashcode.uuid_ref, bill_id: hashcode.bill_id, datahash: hashcode.xfields, hash: hash })

    } else {
      return this.getAjax('messages', 'json/create_hashcode', '', 'POST', 'jsonp', false, { uuid: hashcode.uuid, uuid_ref: hashcode.uuid_ref, bill_id: hashcode.bill_id, datahash: hashcode.xfields })

    }
  },

  //
  /**
   * Carrega uma lista de itens de venda no período determinado
   * @param {*} formDate
   * @returns
   */
  getBillItems(sdate, edate) {
    return this.getAjax('bills', 'bill_items', `?start_date=${sdate}&end_date=${edate}`, 'GET', 'json')
  },

  getAjax(controller, func, queryParams, protocol, responseType, deleteItemID, postData) {
    var ajaxParams = {
      method: protocol || "GET",
      data: {
        bckey: bocapioKey,
      }
    }
    switch (protocol) {
      case 'DELETE':
        ajaxParams.url = cakeBaseURL + controller + "/delete/" + deleteItemID + "/?layout=ajax" + (queryParams || "")
        break
      case 'GET':
        ajaxParams.url = cakeBaseURL + controller + "/json/" + func + "/" + (queryParams || "")
        ajaxParams.dataType = responseType || "jsonp"  //The type of data that you're expecting back from the server
        //ajaxParams.contentType = "jsonp; charset=UTF-8" //When sending data to the server, use this content type. Default: "application/x-www-form-urlencoded; charset=UTF-8"
        ajaxParams.async = true
        if (store.getters.accessToken) {
          ajaxParams.data['x-access-token'] = `${store.getters.accessToken}`
        }
        break;
      case 'POST':
        ajaxParams.url = cakeBaseURL + controller + "/" + func + "/" + (queryParams || "")
        // ajaxParams.dataType = responseType || "jsonp",
        if (store.getters.accessToken) {
          ajaxParams.data['x-access-token'] = `${store.getters.accessToken}`
        }

        // ajaxParams.type = "POST"
        // ajaxParams.processData = false
        // ajaxParams.contentType = false
        // postData.images = false
        ajaxParams.headers = {
          // "Content-Type": "multipart/form-data"
        }

        ajaxParams.data['postData'] = postData
        break
      default:
        ajaxParams.url = cakeBaseURL + controller + "/json/" + func + "/" + (queryParams || "")
        break
    }
    ajaxParams.url = handleCache(ajaxParams.url)

    return jQuery
      .ajax(ajaxParams)
      .done(function (response, textStatus) {
        //undefined or true
        if (response.loggedin === 'false') {
          console.warn('guest api response')
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        console.error("CakePHP Service::getAjax(). Erro ao carregar dados do servidor!",ajaxParams.url)
        console.log(jqXHR.responseText)
        console.log(textStatus)
        console.log(errorThrown)
      })
      .always(function () { });
  },

  getTransactions(func, sdate, edate) {
    //, categories, coust_center, clients, agents
    var queryParams = func +
      "/sdate:" +
      sdate +
      "/edate:" +
      edate +
      "/transactions_input_categories:/coust_center:/clients:/agents:/?pm_detail=true&layout=ajax";

    return this.getAjax('transactions', 'globalsearch', queryParams, 'GET', 'json')
  },

























  /*
    getOrders() {
      return jQuery
        .ajax({
          type: 'GET',
          url: 'https://janoo.com.br/wp-json/janoo-api/v1/orders?start_date=2022-09-01&end_date=2022-09-30&api_key=35290396-CDD4-12EB-B8BC-0242AC130003&bocapio_key=395EECC7-3847-11ED-8AB5-F23C9227EC8D',
          beforeSend: function (xhr) {
            const token = btoa('suporte' + ':' + '6OZ5APGZo5JvL&JeFUAuvgjF')
            xhr.setRequestHeader('Authorization', 'Basic ' + token);
          },
          // data: {
          //     'title': 'Post using REST API',
          //     'content': 'Post content using REST API',
          //     'status': 'publish'
          // },
          success: function (response) {
            console.log(response);
          },
          fail: function (response) {
            console.log(response);
          },
          //dataType: "jsonp",
          async: true
        });
    },
    *
  getAjaxAgents(controller, func, queryParams, protocol, responseType) {
    // func, , deleteItemID
    var _url =
      func !== "delete"
        ? cakeBaseURL +
        controller +
        "/json/" +
        func +
        "/" +
        (queryParams || "")
        : cakeBaseURL +
        controller +
        "/delete/" +
        //deleteItemID +
        // "view" +
        (queryParams || "");

    // _url = '//apps-dev.bocapio.com.br/products/json/list/?&layout=ajax';
    //   _url = handleCache(_url)
    // console.error(_url);

    return jQuery
      .ajax({
        type: protocol || "GET",
        url: _url,
        dataType: responseType || "jsonp",
        data: { bckey: bocapioKey },
        async: true
      })
      .done(function (response, textStatus) {})
      .fail(function (jqXHR, textStatus, errorThrown) {
        console.error("CakePHP Service:: Erro ao carregar dados do servidor");
        console.log(jqXHR.responseText);
        console.log(textStatus);
        console.log(errorThrown);
      })
      .always(function () { });
  },
  */
  getAgentByUUID(uuid) {

    return jQuery
      .ajax({
        type: "GET",
        url: handleCache(cakeBaseURL + "agents/json/view/" + uuid),
        dataType: "jsonp",
        data: { bckey: bocapioKey },
        async: true
      })
      .done(function (response, textStatus) { })
      .fail(function (jqXHR, textStatus, errorThrown) {
        console.error("CakePHP Service:: Erro ao carregar dados do servidor" + cakeBaseURL + "agents/json/view/" + uuid);
        console.log(jqXHR.responseText);
        console.log(textStatus);
        console.log(errorThrown);
      })
      .always(function () { });
  },
  getDomainName(hostName) {
    if (undefined == hostName) {
      hostName = window.location.hostname
    }
    hostName = hostName.split('.')
    hostName.shift(1)
    hostName = hostName.join('.')
    hostName = hostName.replaceAll('/', '')
    return 'sistema.' + hostName + '/'
  }

};
